module.exports = __webpack_public_path__ + "img/icon_default_avatar.e3c29a40.svg";